import React from 'react';
import styled from 'styled-components';
import './App.css';
import { ThemeProvider } from './ThemeContext';

// Import components
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Awards from './components/Awards';
import Patents from './components/Patents';
import Contact from './components/Contact';
import Recommendations from './components/Recommendations';
import Philanthropy from './components/Philanthropy';

const AppContainer = styled.div`
  font-family: 'Poppins', sans-serif;
`;

const Footer = styled.footer`
  background-color: var(--color-card);
  color: var(--color-text);
  padding: 1.5rem 2rem;
  border-top: 1px solid var(--color-shadow);
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    padding: 1rem;
    flex-direction: column;
    gap: 0.5rem;
    text-align: center;
  }
`;

const CopyrightText = styled.p`
  margin: 0;
  font-size: 0.9rem;
  color: var(--color-secondary);
  
  @media (max-width: 576px) {
    font-size: 0.8rem;
  }
`;

const DesignerInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: var(--color-secondary);
  
  @media (max-width: 576px) {
    font-size: 0.8rem;
  }
`;

const DesignerName = styled.span`
  color: var(--color-text);
  font-weight: 600;
`;

const LinkedInIcon = styled.a`
  color: var(--color-primary);
  font-size: 1.2rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  
  &:hover {
    color: var(--color-secondary);
    transform: translateY(-2px);
  }
  
  @media (max-width: 576px) {
    font-size: 1.1rem;
  }
`;

function App() {
  return (
    <ThemeProvider>
      <AppContainer>
        <Navbar />
        <Hero />
        <About />
        <Experience />
        <Patents />
        <Awards />
        <Philanthropy />
        <Recommendations />
        <Contact />
        <Footer>
          <div style={{ flex: 1, textAlign: 'left' }}>
            <CopyrightText style={{ color: '#ffff', fontWeight: 500 }}>
              © 2025 Surendar VP
            </CopyrightText>
          </div>
          <div style={{ flex: 1, textAlign: 'center' }}>
            <CopyrightText>
              All Rights Reserved.
            </CopyrightText>
          </div>
          <div style={{ flex: 1, textAlign: 'right', display: 'flex', justifyContent: 'flex-end' }}>
            <DesignerInfo>
              Designed by <DesignerName>Krish</DesignerName>
              <LinkedInIcon href="https://www.linkedin.com/in/dsrkreddy81" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-linkedin"></i>
              </LinkedInIcon>
            </DesignerInfo>
          </div>
        </Footer>
      </AppContainer>
    </ThemeProvider>
  );
}

export default App;
